export default {
      id: "submenu-shape-usage",
      viewBox: "0 0 720 260",
      url: "../../assets/" + "sprite.svg#submenu-shape-usage",
      toString: function () {
        return this.url;
      }
    }